/**
 * Load Balance Board — shared types.
 *
 * The small vocabulary every piece of the board speaks: which screen and
 * sub-view are up, the visible hour window, and the cover a planner drafts
 * on the skill-gap board before it becomes a real flex / OT request.
 */

/** View 1's sub-views. */
export type BoardView = "Week" | "Day";

/** Which metric is active — the metric IS the navigation. */
export type BoardScreen = "util" | "gaps" | "flex";

/** The visible hour window, in decimal hours into the day. */
export interface Clock {
	start: number;
	end: number;
}

/** yyyy-MM-dd the worker's standing pin on a work center ends on the shown day, if one covers it. */
export type PinEnd = (workerId: string, workstation: string | null | undefined) => string | null;

export type CoverMethod = "ot" | "flex" | "pull";

export const COVER_LABEL: Record<CoverMethod, string> = {
	ot: "4h OT block",
	flex: "Flex request",
	pull: "Pulled from another line",
};

export type RequestStatus = "DRAFT" | "OPEN" | "FILLED";

export interface FlexRequestRow {
	key: string;
	workcenter: string;
	jobRole: string;
	window: string;
	method: CoverMethod;
	heads: number;
	status: RequestStatus;
	/** Enough to actually open the shift — resolved when the draft is made. */
	jobRoleId: number | null;
	startIso: string;
	endIso: string;
	/** Set once the request exists in the flex scheduler. */
	shiftId?: number;
	/** Spots still unclaimed, from the flex service. */
	spotsLeft?: number;
}
